import styled from "styled-components";
import { themeTypes } from "../../styled/Theme";

export const StyledClub = styled.div`
  font-family: MLSTifo;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: ${(props) => props.theme.mixins.pxToRem("16")};
  line-height: 18px;
  color: ${(props) =>
    props.theme.type == themeTypes.light
      ? props.theme.figma.base.color_offblack_100
      : props.theme.figma.base.color_white_100};

  &.mls-c-club {
    &.--home {
      flex-direction: row-reverse;
      margin-right: 8px;
    }

    &.--away {
      margin-left: 8px;
    }

    &.--home .mls-c-club__abbreviation,
    &.--home .mls-c-club__fullname,
    &.--home .mls-c-club__shortname {
      margin-right: 6px;
    }

    &.--away .mls-c-club__abbreviation,
    &.--away .mls-c-club__fullname,
    &.--away .mls-c-club__shortname {
      margin-left: 6px;
    }

    .mls-c-club__rank {
      font-size: 11px;
      vertical-align: top;
      font-weight: 400;
    }

    &.--home .mls-c-club__rank {
      margin-right: 4px;
    }

    &.--away .mls-c-club__rank {
      margin-left: 4px;
    }
  }
`;

export const StyledClubName = styled.div`
  display: flex;
`;
